module.exports = __webpack_public_path__ + "img/TPW-Logo-weiss.711df4bb.png";